import {Part} from "../part";
import DesignNavigationItem from "../../../visComponents/designNavigationItem";
import {PartMenuType} from "../../../visComponents/constants";
import {vanityThumbnail} from "../../../bvComponent/core/assets";

import CompleteVanity from "../subparts/vanity/completeVanity";
import VanityHandle from "../subparts/vanity/vanityHandle";
import VanityCabinet from "../subparts/vanity/vanityCabinet";
import VanityCountertop from "../subparts/vanity/vanityCountertop";
import VanityBacksplash from "../subparts/vanity/vanityBacksplash";
import Mirror from "../subparts/vanity/mirror";
import Sink from "../subparts/vanity/sink";
import VanityFaucet from "../subparts/vanity/faucet";

export class Vanity extends Part {
  static id = 'Vanity';

  static Types = {
    Complete: 'Complete',
    Custom: 'Custom'
  };

  constructor() {
    super(true, false, PartMenuType.Complex);

    this.menuType = PartMenuType.Complex;
    this.partName = 'Vanity';
    this.translateId = "visualizer.bathroom.vanity";
    this.partThumbnail = vanityThumbnail;
    this.activeSubType_ = Vanity.Types.Custom;
    this.relatedItems = [];
    this.placeholdersNeeded = false;  // only Vanity property

    // vanity parts
    this.vanityCabinet = null;
    this.completeVanity = null;
    this.countertop = null;
    this.sink = null;
    this.faucet = null;
    this.vanityBacksplash = null;
    this.vanityHandle = null;
    this.mirror = null;
  }

  load(dbFeature) {
    let relatedItemName = "",
      RelatedItemClass = null;
    switch (dbFeature.groupName) {
      case "Sink":
        relatedItemName = "sink";
        RelatedItemClass = Sink;
        break;
      case "Mirror":
        relatedItemName = "mirror";
        RelatedItemClass = Mirror;
        break;
      case "Countertop":
        relatedItemName = "countertop";
        RelatedItemClass = VanityCountertop;
        break;
      case "Faucet":
        relatedItemName = "faucet";
        RelatedItemClass = VanityFaucet;
        break;
      case "VanityBacksplash":
      case "BackSplash":
      case "Backsplash":
        relatedItemName = "vanityBacksplash";
        RelatedItemClass = VanityBacksplash;
        break;
      case "Vanity Handle":
        relatedItemName = "vanityHandle";
        RelatedItemClass = VanityHandle;
        break;
      case "Vanity": {
        const completeVanity = dbFeature.metaData && dbFeature.metaData["Vanity"]
          && dbFeature.metaData["Vanity"].includes("Complete");

        relatedItemName = completeVanity ? "completeVanity" : "vanityCabinet";
        RelatedItemClass = completeVanity ? CompleteVanity : VanityCabinet;
        break;
      }
    }
    if (relatedItemName) {
      if (!this[relatedItemName]) {
        this[relatedItemName] = new RelatedItemClass(true);
        if (relatedItemName === "sink") {
          const faucetIndex = this.relatedItems.findIndex(relItem => relItem.partName === 'Faucet');
          faucetIndex ? this.relatedItems.splice(faucetIndex, 0, this.sink) : this.relatedItems.push(this.sink);
        } else if (relatedItemName === "completeVanity") {
          this.relatedItems.unshift(this.completeVanity); // cabinet needs to be first in the list.
        } else if (relatedItemName === "vanityCabinet") {
          this.relatedItems.unshift(this.vanityCabinet); // cabinet needs to be first in the list.
        } else {
          this.relatedItems.push(this[relatedItemName]);
        }
      }
      if (!this.categoryEnabled) {
        this.categoryEnabled = true
      }
      this[relatedItemName].getParent = () => this;
      this[relatedItemName].load(dbFeature);
      return true
    }
    return false
  }

  getRelatedItems() {
    return this.relatedItems.filter(item => item.visible.includes(this.activeSubType_));
  }

  subTypes() {
    return this.vanityCabinet && this.completeVanity ? [Vanity.Types.Custom, Vanity.Types.Complete] : [];
  }

  isSubTypeWithItems() {
    return this.activeSubType_ === Vanity.Types.Complete;
  }

  activeSubType() {
    return this.activeSubType_;
  }

  subParts() {
    const relatedItems = this.getRelatedItems();
    const excluded = [];
    const vanityPart = relatedItems.find(navItem => navItem.partId === "vanity_cabinet");
    if (vanityPart && vanityPart.activeFeature
      && vanityPart.activeFeature.metaData["VanityHandle"]
      && vanityPart.activeFeature.metaData["VanityHandle"].includes("None")) {
      excluded.push("vanity_handle")
    }
    return relatedItems
      .filter(item => !excluded.includes(item.partId))
      .map(_ => new DesignNavigationItem(_.partName, _));
  }

  // subPartsWithAccentWall() {
  //   const vanityAccent = this.layout.parts.Walls.vanityAccent;
  //   return [new DesignNavigationItem(vanityAccent.partName, vanityAccent),
  //     ...this.getRelatedItems().map(_ => new DesignNavigationItem(_.partName, _))];
  // }

  handleSubTypeClick(subType) {
    this.activeSubType_ = subType;
    this.getRelatedItems().forEach((relatedItem) => {
      if (!relatedItem.activeFeature) {
        relatedItem.setDefault()
      }
    });
  }

  setDefaultPartAfterSubTypeClick() {
    return this.subParts()[0]
  }

  setDefault(layout) {
    this.getRelatedItems().forEach(_ => _.setDefault(layout));
  }

  counterTopSize() {
    return this.getCounterTopSize() || "24";  // temporary hardcode until we would have meta data finished
  }

  getCounterTopSize() {
    if (this.vanityCabinet && !this.vanityCabinet.activeFeature) {
      this.vanityCabinet.setDefault()
    }
    return (this.vanityCabinet && this.vanityCabinet.activeFeature)
      ? this.vanityCabinet.activeFeature.dbFeature.metaData["VanitySize"]
      : null;
  }

  toggleVanityParts(disabled) {
    this.getRelatedItems().forEach(relItem => {
      if (relItem.partId === "vanity_sink" || relItem.partId === "vanity_faucet"
        || relItem.partId === "vanity_countertop" || relItem.partId === "vanity_cabinet"
        || relItem.partId === "vanity_handle" || relItem.partId === "vanity_backsplash") {
        relItem.disabled = disabled;
      }
    });
  }
}

